export default __webpack_public_path__ + "static/media/boatIcon.fb7eb1d0.svg";